import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row g-0" }
const _hoisted_3 = { class: "col-12 col-xl-3 header__logos" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "col"
}
const _hoisted_9 = {
  key: 1,
  class: "col-auto align-self-center"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "d-none d-lg-block col-lg-auto" }
const _hoisted_12 = {
  href: "https://www.instagram.com/stadtcastroprauxel/",
  target: "_blank"
}
const _hoisted_13 = { class: "d-none d-lg-block col-lg-auto" }
const _hoisted_14 = {
  href: "https://www.facebook.com/StadtCastropRauxel",
  target: "_blank"
}
const _hoisted_15 = { class: "d-none col-lg-auto header_buttons" }
const _hoisted_16 = { class: "d-none col-lg-auto header_buttons aussteller" }
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 0,
  class: "mobil-menu"
}
const _hoisted_19 = { class: "menu" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = {
  href: "https://www.instagram.com/stadtcastroprauxel/",
  target: "_blank"
}
const _hoisted_22 = { class: "" }
const _hoisted_23 = {
  href: "https://www.facebook.com/StadtCastropRauxel",
  target: "_blank"
}
const _hoisted_24 = { class: "header_buttons aussteller" }
const _hoisted_25 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIconRound = _resolveComponent("ButtonIconRound")!

  return (_openBlock(), _createElementBlock("header", {
    style: _normalizeStyle(`top:${_ctx.header.top}px`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", { href: _ctx.homeUri }, [
            _createElementVNode("img", {
              class: "header__logo",
              src: `${_ctx.themeUri}/assets/img/Stadtwerke_Castrop-Rauxel _Logo.svg`
            }, null, 8, _hoisted_5)
          ], 8, _hoisted_4),
          _createElementVNode("a", { href: _ctx.homeUri }, [
            _createElementVNode("img", {
              class: "header__logo wirtschaft",
              src: `${_ctx.themeUri}/assets/img/Wirtschaf_Marketing_Logo.svg`
            }, null, 8, _hoisted_7)
          ], 8, _hoisted_6)
        ]),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
          : _createCommentVNode("", true),
        (!_ctx.isMobile)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", _hoisted_12, [
                    _createVNode(_component_ButtonIconRound, {
                      icon: "fab fa-instagram",
                      title: "Instagram"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("a", _hoisted_14, [
                    _createVNode(_component_ButtonIconRound, {
                      icon: "fab fa-facebook-f",
                      title: "Facebook"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.scrollToKarriereheld && _ctx.scrollToKarriereheld(...args)))
                  }, " Zur Jobbörse ")
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("a", {
                    href: `${_ctx.themeUri}/assets/pdf/CAS_Karrierehelden_Flyer.pdf`,
                    target: "_blank"
                  }, " Aussteller werden ", 8, _hoisted_17)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("a", _hoisted_21, [
                _createVNode(_component_ButtonIconRound, {
                  icon: "fab fa-instagram",
                  title: "Instagram"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("a", _hoisted_23, [
                _createVNode(_component_ButtonIconRound, {
                  icon: "fab fa-facebook-f",
                  title: "Facebook"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("a", {
                href: `${_ctx.themeUri}/assets/pdf/CAS_Karrierehelden_Flyer.pdf`,
                target: "_blank"
              }, " Aussteller werden ", 8, _hoisted_25)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}